import { reset as _reset } from '../../actions/authentication';
import { create as _create } from '../../actions/social';
import { changeView as _changeView } from '../../actions/view';
import { disabledSelector, emailSelector, errorSelector, hasErrorSelector, phoneSelector } from './selectors';
import { SocialCreateViewContainer as Component } from './SocialCreateViewContainer';
import { connect } from 'react-redux';

function mapStateToProps(state) {
  return {
    disabled: disabledSelector(state),
    hasError: hasErrorSelector(state),
    error: errorSelector(state),
    storedPhone: phoneSelector(state),
    storedEmail: emailSelector(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    reset: function reset() {
      dispatch(_reset());
    },
    create: function create(params) {
      dispatch(_create(params));
    },
    changeView: function changeView(view) {
      dispatch(_changeView(view));
    }
  };
}

export var SocialCreateViewContainer = connect(mapStateToProps, mapDispatchToProps)(Component);